export default interface BusinessPhoneNumber {
  id: number;
  phoneNumber: string;
  phoneNumberExtension: string;
  phoneNumberType: BusinessPhoneNumberType;
  deleted: boolean;
  primary: boolean;
}

export enum BusinessPhoneNumberType {
  CELL = 1,
  FAX = 2,
  WORK = 3,
}



// WEBPACK FOOTER //
// ./src/models/contact/business-phone-number.ts